import script from "./FreeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeCard.vue?vue&type=script&setup=true&lang=js"

import "./FreeCard.vue?vue&type=style&index=0&id=1800f4de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1800f4de"]])

export default __exports__